import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Page from '@lib/components/v2/Page';
import classNames from 'classnames';
import classes from './MedicareNames.style.module.scss';

class MedicareNames extends Component {
  static propTypes = {
    names: PropTypes.array,
    onSelected: PropTypes.func,
    onGoBack: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      optionList: []
    };
    this.handleNextStep = this.handleNextStep.bind(this);
  }

  async componentDidMount() {
    const { names = {} } = this.props;
    const optionList = await Object.keys(names).map((key) => {
      return {
        title: `${key} ${names[key]}`,
        checked: false
      };
    });
    this.setState({
      optionList
    });
  }

  handleNextStep(e) {
    if (e) {
      e.preventDefault();
    }
    const { onSelected } = this.props;
    const { optionList } = this.state;
    const selectedItem = optionList.find((item) => item.checked);
    if (selectedItem) {
      const parts = selectedItem.title.split(/\s(.+)/);
      const data = {
        fullName: parts[1],
        medicareRefNumber: parts[0]
      };
      onSelected(data);
    } else {
      console.error('Please select a name');
    }
  }

  onOptionClick(item, index) {
    if (item.checked) {
      return;
    }

    const { optionList } = this.state;
    for (let i = 0; i < optionList.length; i++) {
      optionList[i].checked = index === i;
    }
    this.setState({ optionList });
  }

  /**
   * Render the component's markup
   * @return {ReactElement}
   */
  render() {
    const { onGoBack } = this.props;
    const { optionList } = this.state;
    const footerButtons = [
      {
        label: 'Back',
        variant: 'transparent',
        onClick: onGoBack
      },
      {
        label: 'Continue',
        type: 'submit',
        onClick: this.handleNextStep
      }
    ];

    return (
      <Page buttons={footerButtons}>
        <div className={classes.wrapper}>
          <div className={classes.heading}>Which number reference are you?</div>
          <div className={classes.option_list}>
            {optionList.map((item, index) => {
              const iconName = `images/icons/svg/${
                item.checked ? 'icon_radio_checked.svg' : 'icon_radio_unchecked.svg'
              }`;

              return (
                <div
                  key={item.title}
                  className={classNames(classes.option_item, item.checked && classes.checked)}
                  onClick={() => this.onOptionClick(item, index)}
                >
                  <div className={classes.check_mark_wrapper}>
                    <img src={iconName} alt="" />
                  </div>
                  <div className={classes.option_title}>{item.title}</div>
                </div>
              );
            })}
          </div>
        </div>
      </Page>
    );
  }
}

export default MedicareNames;
